import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=cf9bcab2&scoped=true"
import script from "./Cases.vue?vue&type=script&lang=js"
export * from "./Cases.vue?vue&type=script&lang=js"
import style0 from "./Cases.vue?vue&type=style&index=0&id=cf9bcab2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9bcab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf9bcab2')) {
      api.createRecord('cf9bcab2', component.options)
    } else {
      api.reload('cf9bcab2', component.options)
    }
    module.hot.accept("./Cases.vue?vue&type=template&id=cf9bcab2&scoped=true", function () {
      api.rerender('cf9bcab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/self-select-stock/components/Cases.vue"
export default component.exports